export const REACT_APP_MAGIC_PUBLISHABLE_KEY = "pk_live_30822EE505697402"
export const ALCHEMY_NODE = "https://polygon-mainnet.g.alchemy.com/v2/nFs45MKXjdrLEJ8WUdFkyQqC6ChQQHS7"
export const CHAIN_ID = 137
export const ERC20_ADDRESS = "0xed3004e8b62cf241a2fe4B2347Ca316ef15F539e"
export const API_ROOT = "https://api.lifise.io/api/v1"
export const TOAST_OPTIONS = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    progress: undefined,
    theme: "colored",
}
export const EXPLORER = "https://polygonscan.com"

// European countries with their phone codes
export const europeanCountries = [
    { name: 'France', code: '33' },
    { name: 'Guadeloupe', code: '590' },
    { name: 'Martinique', code: '596' },
    { name: 'French Guiana', code: '594' },
    { name: 'Réunion', code: '262' },
    { name: 'Mayotte', code: '262' },
    { name: 'French Polynesia', code: '689' },
    { name: 'New Caledonia', code: '687' },
    { name: 'Germany', code: '49' },
    { name: 'Spain', code: '34' },
    { name: 'Italy', code: '39' },
    { name: 'Netherlands', code: '31' },
    { name: 'Belgium', code: '32' },
    { name: 'Austria', code: '43' },
    { name: 'Portugal', code: '351' },
    { name: 'Greece', code: '30' },
    { name: 'Poland', code: '48' },
    { name: 'Czech Republic', code: '420' },
    { name: 'Hungary', code: '36' },
    { name: 'Sweden', code: '46' },
    { name: 'Switzerland', code: '41' },
    { name: 'Denmark', code: '45' },
    { name: 'Finland', code: '358' },
    { name: 'Ireland', code: '353' },
    { name: 'Luxembourg', code: '352' },
    { name: 'Slovenia', code: '386' },
    { name: 'Slovakia', code: '421' },
    { name: 'Croatia', code: '385' },
    { name: 'Bulgaria', code: '359' },
    { name: 'Romania', code: '40' },
    { name: 'Estonia', code: '372' },
    { name: 'Latvia', code: '371' },
    { name: 'Lithuania', code: '370' },
    { name: 'Malta', code: '356' },
    { name: 'Cyprus', code: '357' }
];